<template>
  <div>
    <div class="detail-comment-input">
      <a-textarea placeholder="说点什么..." v-model="commentDesc" />
      <div>
        <span>
          <!-- <img src="@/assets/img/biaoqing.png" />添加表情 -->
        </span>
        <a-button class="btn-green" @click="comment">评论</a-button>
      </div>
    </div>
    <div class="detail-comment-list-body">
      <template v-if="list != ''">
        <div class="detail-comment-list" v-for="item in list" :key="item.id">
          <span><img src="@/assets/img/defaultavatar.png" /></span>
          <div>
            <span>{{ item.commentOperatorName }}</span>
            <p>{{ item.content }}</p>
            <div>
              <span>{{ item.reviewTime }}</span>
              <p>
                <!-- <span> <a-icon type="warning" />举报 </span> -->
                <!-- class="active" -->
                <!-- <span @click="thumbsupBtn(item.id)"> <a-icon type="like" />{{item.thumbsup?item.thumbsup:0}} </span> -->
              </p>
            </div>
          </div>
        </div>
        <div class="home-dynamic-page">
          <a-pagination
            show-quick-jumper
            show-size-changer
            :default-current="page.current"
            :total="page.total"
            :show-total="(total) => `共 ${total} 项`"
            @change="pageChange"
          />
        </div>
      </template>
      <div v-else class="detail-comment-list-no">
        <img src="@/assets/img/nodata.png" />
        <p>当前暂无内容</p>
      </div>
    </div>
  </div>
</template>

<script>
import { achvCommentList, achvComment } from "@/api/achv";
import { mapGetters } from "vuex";
export default {
  props: ["info"],
  data() {
    return {
      list: [],
      page: {
        size: 10,
        current: 1,
        total: 0,
      },
      commentDesc: "",
    };
  },
  computed: mapGetters(["userInfo"]),
  mounted() {
    this.loadachvCommentList();
  },
  methods: {
    loadachvCommentList() {
      achvCommentList(this.page, this.info.id).then((res) => {
        this.list = res.data.records;
        this.page.total = res.data.total;
        this.$emit("comment-change", true);
      });
    },
    pageChange(page) {
      this.page.current = page;
      this.loadachvCommentList();
    },
    comment() {
      if (!this.userInfo) {
        this.$message.warning("您还未登录！");
        return;
      }
      if (!this.commentDesc) {
        this.$message.warning("请输入评论内容");
        return;
      }
      let data = {
        content: this.commentDesc,
      };
      achvComment(data, this.info.id).then((res) => {
        this.$emit("comment-change", true);
        this.commentDesc = "";
        this.loadachvCommentList();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.detail-comment-input {
  margin-bottom: 24px;
  > textarea {
    height: 80px;
    width: 100%;
  }
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    > span {
      display: flex;
      align-items: center;
      color: #8c8c8c;
      font-size: 12px;
      cursor: pointer;
      > img {
        margin-right: 8px;
      }
    }
  }
}
.detail-comment-list {
  display: flex;
  padding: 24px 0;
  border-bottom: 1px solid #f0f0f0;
  > span {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 16px;
    > img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  > div {
    flex: 1;
    > span {
      line-height: 14px;
      font-weight: bold;
      margin-bottom: 20px;
      display: block;
    }
    > p {
      color: #595959;
      line-height: 22px;
      margin-bottom: 20px;
    }
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #bfbfbf;
      font-size: 12px;
      > span {
        line-height: 12px;
      }
      > p {
        display: flex;
        align-items: center;
        > span {
          margin-left: 30px;
          display: flex;
          align-items: center;
          cursor: pointer;
          > i {
            margin-right: 8px;
            font-size: 14px;
          }
          &.active {
            color: #1abc9c;
          }
        }
      }
    }
  }
}
.home-dynamic-page {
  margin-top: 24px;
  text-align: right;
}
.detail-comment-list-no {
  margin: 100px 0;
  > img {
    display: block;
    margin: 0 auto 24px;
  }
  > p {
    text-align: center;
    color: #8c8c8c;
    line-height: 14px;
  }
}
</style>
